export default __webpack_public_path__ + "373adf1df7187c9795e20fedfa8cec30.png";